import { createContext } from "react";

export const ContentListAlternativeViewContext = createContext();

